// import packages
import React from "react";

// import hoc
import { withErrorBoundary } from "lib/hoc";

const XhawiRefundPolicy = () => {
  return (
    <div dangerouslySetInnerHTML={{ __html: `
    <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Xhawi Marketplace Return & Refund Policy</title>
  <style>
    body {
      margin: 0;
      font-family: "Segoe UI", Arial, sans-serif;
      line-height: 1.6;
      color: #111;
      background: #fafafa;
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }

    .content {
      flex: 1;
      padding: 40px 50px;
      max-width: 900px;
      margin: auto;
    }

    h1 {
      font-size: 32px;
      margin-bottom: 10px;
      color: #000;
      border-bottom: 4px solid #b5f75b;
      padding-bottom: 8px;
    }

    h2 {
      margin-top: 30px;
      font-size: 22px;
      color: #000;
      padding-top: 3px;
      padding-bottom: 3px;
    }

    h3 {
      margin-top: 15px;
      font-size: 17px;
      color: #111;
      font-weight: bold;
      margin-left: 15px; /* indent subpoints */
    }

    p, li {
      font-size: 15px;
      color: #222;
    }

    ul {
      margin: 10px 0 20px 40px;
    }

    strong {
      color: #000;
    }

    .section {
      margin-bottom: 25px;
      position: relative;
    }

    .final-note {
      margin-top: 35px;
      padding: 15px;
      background: #b5f75b;
      color: #000;
      font-weight: bold;
      border-radius: 4px;
    }

    footer {
      background: #b5f75b;
      color: #000;
      text-align: center;
      padding: 15px;
      font-size: 14px;
      margin-top: 40px;
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
      .content {
        padding: 20px;
      }
      h1 {
        font-size: 26px;
      }
      h2 {
        font-size: 20px;
      }
      h3 {
        font-size: 16px;
        margin-left: 10px;
      }
      p, li {
        font-size: 14px;
      }
      ul {
        margin-left: 25px;
      }
    }

    @media (max-width: 480px) {
      .content {
        padding: 15px;
      }
      h1 {
        font-size: 22px;
      }
      h2 {
        font-size: 18px;
      }
      h3 {
        font-size: 15px;
        margin-left: 8px;
      }
      p, li {
        font-size: 13px;
      }
      ul {
        margin-left: 20px;
      }
      footer {
        font-size: 13px;
        padding: 12px;
      }
    }
  </style>
</head>
<body>

  <div class="content">
    <h1>Return Policy</h1>
    <h2>Refund Policy</h2>
    <p>
      At XHAWI, customer satisfaction is our top priority. If you are not completely satisfied with your purchase, 
      we offer a comprehensive refund policy categorized based on the nature of the refund request. 
      Please read the following terms carefully before initiating a refund request.
    </p>

    <h2>Refund process:</h2>
    <p><strong>Defective or damaged items:</strong> If your item arrives damaged or faulty, please return it in its original condition with the packaging intact. Once we receive it, we’ll assess the situation and process your refund, including any shipping fees, if applicable.</p>
    <p><strong>Incorrect item received:</strong> If you find yourself with the wrong item, return it in its original condition and packaging. We’ll take care of the refund and offer complimentary returns for up to 15 days.</p>
    <p><strong>Change of mind:</strong> If you decide to cancel your order before it ships, or within 15 days of receiving it, you can get a refund to your original payment method, minus shipping costs. Please ensure that items are in their original packaging and condition. Not applicable to products part of Xhawi Flash Deals.</p>
    <p><strong>Credit card transactions:</strong> Refunds for cancelled orders will automatically be credited back to your credit or debit card within 5-7 business days. For items returned that meet our criteria, refunds will be transferred back to your card upon request.</p>
    <p><strong>Cash on delivery transactions:</strong> Refunds for cash on delivery orders will be issued as store credits, which you can use for future purchases or request to be transferred to your bank account.</p>

    <div class="section">
      <h2>1. Defective or damaged products</h2>
      <h3>Eligibility</h3>
      <p>The product must be unused and in the same condition as when you received it (sealed/unopened if applicable, with the original box, packaging, manual, warranty card, and all accessories).</p>
      <p>You must provide proof of the damage or defect (e.g., photos).</p>
      <h3>Time frame</h3>
      <p>You must request a refund or replacement within 2 days of receiving the product.</p>
      <h3>Process</h3>
      <p>Contact our support team at <strong>care@xhawi.com</strong> with your order number, photos of the defective or damaged product, and a description of the issue. Once approved, we will provide a shipping label for the return. After receiving the product, we will process your refund or ship a replacement within 7 business days.</p>
    </div>

    <div class="section">
      <h2>2. Incorrect or wrong item delivered</h2>
      <h3>Eligibility</h3>
      <p>The item must be unused, in its original packaging, and in the same condition as when you received it.</p>
      <h3>Time frame</h3>
      <p>You must request a refund or replacement within 2 days of receiving the wrong product.</p>
      <h3>Process</h3>
      <p>Contact our support team with your order number and details of the wrong item received. We will arrange for the incorrect item to be returned to us and will process your refund or ship the correct item as soon as possible.</p>
    </div>

    <div class="section">
      <h2>3. Change of mind (returns)</h2>
      <h3>Eligibility</h3>
      <p>The product must be unused, unopened, and in its original packaging. Certain products (e.g., perishable goods, digital downloads, personalized items & products part of Xhawi Flash Deals) are not eligible.</p>
      <h3>Time frame</h3>
      <p>You must request a refund within 14 days of receiving the product.</p>
      <h3>Process</h3>
      <p>Contact our support team with your order number and reason for return. You will be responsible for shipping costs. Once we receive and inspect the product, we will process the refund (minus shipping fees) within 7 business days.</p>
    </div>

    <div class="section">
      <h2>4. Late or missing orders</h2>
      <h3>Eligibility</h3>
      <p>Orders that are significantly delayed without prior communication from our team.</p>
      <h3>Time frame</h3>
      <p>Contact us within 2 days from the expected delivery date.</p>
      <h3>Process</h3>
      <p>Reach out to our support team with your order number. We will investigate and either refund or reship the item.</p>
    </div>

    <div class="section">
      <h2>5. Refunds for subscription-based services or products</h2>
      <h3>Eligibility</h3>
      <p>If you cancel a subscription after partial use, we will refund the unused portion.</p>
      <h3>Time frame</h3>
      <p>Subscription cancellations must be requested at least 14 days before the next billing cycle.</p>
      <h3>Process</h3>
      <p>Contact our support team with your subscription details. Refunds are processed within 14 days of cancellation.</p>
    </div>

    <div class="section">
      <h2>6. Non-refundable items</h2>
      <p>Some products and services are non-refundable, including but not limited to:</p>
      <ul>
        <li>Digital products (e.g., e-books, software)</li>
        <li>Personalized/custom-made items</li>
        <li>Perishable goods (e.g., food items)</li>
        <li>Items purchased on final sale</li>
        <li>Perfumes, cosmetics, undergarments, socks (for hygiene reasons)</li>
        <li>Furniture that has been assembled</li>
        <li>Products part of Xhawi Flash Deals</li>
      </ul>
    </div>

    <div class="section">
      <h2>7. General refund conditions</h2>
      <ul>
        <li>All returned products must be in their original condition, with packaging and tags intact.</li>
        <li>Refunds will be issued to the original payment method.</li>
        <li>Shipping costs are non-refundable except in cases where we are responsible (e.g., defective or incorrect items).</li>
      </ul>
    </div>

    <div class="section">
      <h2>8. How to request a refund</h2>
      <p>To request a refund, please follow these steps:</p>
      <ul>
        <li>Contact our customer service team at <strong>care@xhawi.com</strong> with your order number and reason for the refund request.</li>
        <li>Our team will review your request and provide a resolution within 7 days.</li>
        <li>If approved, the refund will be processed within 7 business days, and the amount will be credited to your original payment method.</li>
      </ul>
    </div>

    <div class="final-note">
      Contact us if you have any questions regarding our refund policy: <strong>care@xhawi.com</strong>
    </div>
  </div>
</body>
</html>

    ` }} />
  );
};

export default withErrorBoundary(XhawiRefundPolicy);
